const loaderClass = ".js-loader";
let loader = document.querySelector(loaderClass);

function showLoader(loaderWrapper) {
  loader = (loaderWrapper && loaderWrapper.querySelector(loaderClass)) || loader;

  if (loader) {
    loader.classList.add("m-loading");
  }
}

function hideLoader(loaderWrapper) {
  loader = (loaderWrapper && loaderWrapper.querySelector(loaderClass)) || loader;

  if (loader) {
    loader.classList.remove("m-loading");
  }
}

export { showLoader, hideLoader };
